import { render, staticRenderFns } from "./SayHello.vue?vue&type=template&id=a4e244fa&scoped=true"
import script from "./SayHello.vue?vue&type=script&lang=js"
export * from "./SayHello.vue?vue&type=script&lang=js"
import style0 from "./SayHello.vue?vue&type=style&index=0&id=a4e244fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e244fa",
  null
  
)

export default component.exports